.exchange_text {
	font-size: 13px;

	.exchange {
		text-decoration: underline;
		color: #5a8217;
		cursor: pointer;
		font-weight: 500;
	}
}
